import React from 'react';
import { Cell, Grid } from '@faceless-ui/css-grid';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import { BlockContainer } from '../../components/layouts';
import type { PagesQuery } from '../../graphql/generated/schema';
import { RichText } from '../../components';
import styles from './styles.module.scss';

export const Comparisons: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'Comparisons'>> = ({
  blockSettings,
  leftContent,
  showLeftContent,
  secondaryComparison,
  primaryComparison,
}) => (
  <div className={styles.outerContainer}>
    <BlockContainer
      blockSettings={blockSettings}
      className={styles.container}
    >
      <Grid className={styles.gridContainer}>
        {
          showLeftContent && (
            <Cell
              cols={4}
              colsL={12}
              className={styles.leftContentCell}
            >
              <RichText data={leftContent} />
            </Cell>
          )
        }
        <Cell
          cols={8}
          colsL={12}
          className={styles.rightComparisonRow}
        >
          <div className={styles.secondaryCard}>
            <RichText data={secondaryComparison} />
          </div>
          <div className={styles.primaryCard}>
            <RichText data={primaryComparison} />
          </div>
        </Cell>
      </Grid>
      {
        showLeftContent && (
          <div className={styles.backgroundDecorativeCard} />
        )
      }
    </BlockContainer>
  </div>
);
